import { useEffect, useState } from "react";
import { ArrowRightLeft } from "lucide-react";
import { useI18n } from "../i18n";
import { getRates } from "../api";

export default function CurrencyConverter() {
  const { t, lang } = useI18n();
  const [rates, setRates] = useState({});
  const [amount, setAmount] = useState(100);
  const [from, setFrom] = useState("USD");
  const [to, setTo] = useState("SAR");

  useEffect(() => {
    getRates().then((r) => setRates(r.rates || {}));
  }, []);

  const convert = () => {
    if (!rates[from] || !rates[to]) return 0;
    const usd = amount / rates[from];
    return (usd * rates[to]).toFixed(2);
  };

  const swap = () => { setFrom(to); setTo(from); };

  return (
    <div className="rounded-3xl bg-white border border-[#E6DED3] p-6" data-testid="currency-converter">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-xl text-[#1C1917]">{t("currency_conv")}</h3>
      </div>

      <div className="space-y-3">
        <div>
          <label className="text-[10px] uppercase tracking-widest text-[#78716C]">{t("amount")}</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value) || 0)}
            data-testid="conv-amount"
            className="w-full h-12 px-4 mt-1 rounded-xl bg-[#F3EDE4] focus:bg-white border border-transparent focus:border-[#1C1917] outline-none text-lg font-medium"
          />
        </div>

        <div className="grid grid-cols-[1fr_auto_1fr] gap-3 items-end">
          <CurrencySelect label={t("from")} value={from} onChange={setFrom} rates={rates} testid="conv-from" />
          <button
            onClick={swap}
            className="h-11 w-11 rounded-full bg-[#1C1917] text-[#FAF7F2] hover:bg-[#C85A32] grid place-items-center transition-colors"
            data-testid="conv-swap"
          >
            <ArrowRightLeft className="h-4 w-4" />
          </button>
          <CurrencySelect label={t("to")} value={to} onChange={setTo} rates={rates} testid="conv-to" />
        </div>

        <div className="mt-4 p-4 rounded-2xl bg-[#1C1917] text-[#FAF7F2]">
          <div className="text-[10px] uppercase tracking-widest opacity-70">{t("result")}</div>
          <div className="font-display text-3xl mt-1" data-testid="conv-result">
            {convert()} <span className="text-base opacity-70">{to}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

function CurrencySelect({ label, value, onChange, rates, testid }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-widest text-[#78716C]">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="w-full h-11 px-3 mt-1 rounded-xl bg-[#F3EDE4] border border-transparent focus:border-[#1C1917] outline-none text-sm font-medium"
      >
        {Object.keys(rates).map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>
    </div>
  );
}
